// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"346":"352dc6ec","825":"ff268af3"}[chunkId] + ".js";
};